import { createFeature, createReducer, on } from '@ngrx/store';
import { GuideActions } from '../actions/guide.actions';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ErrorStore, Guide } from '@sleipai/sleip-models';

export const guideStoreFeatureKey = 'guideStore';

export interface State extends EntityState<Guide> {
  loaded: boolean;
  loading: boolean;
  error: ErrorStore | null;
}

export const adapter: EntityAdapter<Guide> = createEntityAdapter<Guide>();

export const initialState: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  error: null,
});

export const reducer = createReducer(
  initialState,
  on(GuideActions.loadGuides, (state) => {
    return {
      ...state,
      loading: true,
      error: null,
    };
  }),
  on(GuideActions.loadGuidesSuccess, (state, { guides }) => {
    return adapter.upsertMany(guides, {
      ...state,
      loading: false,
      loaded: true,
    });
  }),
  on(GuideActions.loadGuidesFailure, (state, { error }) => {
    return {
      ...state,
      loaded: true,
      loading: false,
      error: {
        message: error['message'],
        status: error['status'],
      },
    };
  })
);

export const guideStoreFeature = createFeature({
  name: guideStoreFeatureKey,
  reducer,
});

export const {
  selectIds: selectGuidesEntitiesIdsAdapter,
  selectEntities: selectGuidesEntitiesAdapter,
  selectAll: selectAllGuidesAdapter,
  selectTotal: selectGuidesTotalAdapter,
} = adapter.getSelectors();
